import View from "core/view";
import Element from "app/element";
import Deferred from "core/deferred";
import PlayerIcon from "core/player-icon";
export default function ChooseFigureView(element) {
  const view = View({
    element
  });
  const playerIcons = ["player1", "player2", "player3"].map(name => PlayerIcon(name, "player_stand"));
  let selectedFigure = null;
  let currentDeferred = null;
  const figureChooser = Element("#figure-chooser", element);
  const figures = initFigures(element, playerIcons);
  function execute() {}
  function askForFigure() {
    currentDeferred = new Deferred();
    return currentDeferred.promise;
  }
  function selectPrevFigure() {
    selectedFigure && selectedFigure.setSelected(false);
    if (selectedFigure && selectedFigure.previousElementSibling) {
      selectedFigure = selectedFigure.previousElementSibling;
    } else {
      selectedFigure = figureChooser.firstElementChild;
    }
    selectedFigure && selectedFigure.setSelected(true);
  }
  function selectNextFigure() {
    selectedFigure && selectedFigure.setSelected(false);
    if (selectedFigure && selectedFigure.nextElementSibling) {
      selectedFigure = selectedFigure.nextElementSibling;
    } else {
      selectedFigure = figureChooser.lastElementChild;
    }
    selectedFigure && selectedFigure.setSelected(true);
  }
  function done() {}
  function cancel() {
    if (selectedFigure) {
      selectedFigure.setSelected(false);
      selectedFigure = null;
    }
    currentDeferred.reject("cancel");
  }
  function submit() {
    if (!selectedFigure) return;
    const id = selectedFigure.id;
    console.log("figure submitted", id);
    selectedFigure.setSelected(false);
    selectedFigure = null;
    currentDeferred.resolve(id);
  }
  return Object.assign(view, {
    execute,
    askForFigure,
    selectPrevFigure,
    selectNextFigure,
    done,
    cancel,
    submit
  });
}
function initFigures(element, icons) {
  const figureChooser = Element("#figure-chooser", element);
  return icons.map((icon, index) => {
    const iconElement = Element(document.createElement("div"));
    iconElement.id = `player${index + 1}`;
    iconElement.appendChild(icon);
    figureChooser.appendChild(iconElement);
  });
}